import React, { useEffect, useState } from 'react'
import '../AddToStockModal/AddToStockModal.scss'
import { Button, Checkbox, CircularProgress, FormControl, IconButton, InputLabel, MenuItem, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box } from '@mui/material';
import { Select } from '@mui/material';
import { TextField } from '@mui/material';
import { ProductManagerTableRow } from '../ProductManagerTableItems/ProductManagerTableRow';
import StockHistoryModalTableItem from './StockHistoryModalTableItem/StockHistoryModalTableItem';
import { mainApi } from '../../../store/services/mainApi';
import { set } from 'lodash';
import {useDispatch} from "react-redux";
import EditStockHistoryModal from '../EditStockHistoryModal/EditStockHistoryModal';
import AutocompleteTPO from '../../Autocomplete/Autocomplete';

const AddToStockHistoryModal = () => {
  //STATE OF Items
  const dispatch = useDispatch();
  const { data: allProducts, isLoading: isLoadingProducts, isError } = mainApi.useFindAllWordsQuery();
  const [allProductsFiltred, setAllProductsFiltred] = useState([]);
  const [updatePavilionProducts] = mainApi.useHistoryAndUpdatePavilionProductsMutation()
  const { data: historyPavilionProducts, isLoadingHistory, refetch } = mainApi.useGetHistoryPavilionProductsQuery()
  const [historyPavItemDelete] = mainApi.useHistoryPavItemDeleteMutation()
  const [updateHistoryPavilionProducts] = mainApi.useUpdateHistoryPavilionProductsMutation()


  // console.log(historyPavilionProducts)

  const { data: contactsData, isLoading: isLoadingContacts } = mainApi.useGetAllContactsQuery()

  useEffect(() => {
    if (contactsData) {
      setSuppliers(() => contactsData.filter(contact => contact.type == "supplier"))

    }
  }, [contactsData])

  const [suppliers, setSuppliers] = useState([]);
  const [currentSupplier, setCurrentSupplier] = useState(undefined);

  //STATE OF MODAL
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchModal, setSearchModal] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [searchAddModal, setSearchAddModal] = useState('');
  const [isLinkPDFModalOpen, setIsLinkPDFModalOpen] = useState(false);

  //OTHER STATE
  const [isEditMode, setIsEditMode] = useState(false)
  const [showItemsLength, setShowItemsLength] = useState(25)
  const [linkPDFValue, setLinkPDFValue] = useState('')
  const [currentOpenHistoryItem, setCurrentOpenHistoryItem] = useState('')
  // console.log(currentOpenHistoryItem)
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [saveTime, setSaveTime] = useState([]);


  const usr = JSON.parse(localStorage.getItem('acc'))
  const handleUpdateSaveTime = (item) => {
    // Обработка сохранения комментария
    let newTime = prompt("Update time?", item.saveTime)
    if(newTime) {
      updateHistoryPavilionProducts({
        user: usr,
        saveTime: newTime,
        _id: item._id
      })
    }
    //dispatch(mainApi.util.invalidateTags(['HistoryPavilion']))

    setTimeout(() => refetch(), 3000)
  }
  const handleUpdateFacturaNum = (item) => {
    // Обработка сохранения комментария
    let facturaNum = prompt("Update Factura Number?", item.facturaNum)
    if(facturaNum) {
      updateHistoryPavilionProducts({
        user: usr,
        facturaNum: facturaNum,
        _id: item._id
      })
    }
    //dispatch(mainApi.util.invalidateTags(['HistoryPavilion']))

    setTimeout(() => refetch(), 3000)
  }

  const date = new Date().toISOString().split('T')[0].split('-').reverse().join('.');

  //Convert function for search
  function normalizeToEnglish(str) {
    // Карта замены русских букв на английские
    const ruToEnMap = {
      'А': 'A', 'В': 'B', 'С': 'C', 'Е': 'E', 'Н': 'H',
      'К': 'K', 'М': 'M', 'О': 'O', 'Р': 'P', 'Т': 'T',
      'Х': 'X', 'а': 'a', 'в': 'b', 'с': 'c', 'е': 'e',
      'н': 'h', 'к': 'k', 'м': 'm', 'о': 'o', 'р': 'p',
      'т': 't', 'х': 'x'
    };

    return str
      .normalize('NFD') // Разложение символов на базовые и диакритические
      .replace(/[\u0300-\u036f]/g, '') // Удаление диакритических знаков
      .split('')
      .map(char => ruToEnMap[char] || char) // Замена русских букв
      .join('');
  }

  //FILTERED FUNCTIONALITY
  useEffect(() => {
    if (!isLoadingProducts) {
      const array = allProducts?.filter((row) => {
      try {
        return normalizeToEnglish(row.name?.toString())?.toLowerCase().includes(searchAddModal?.toLowerCase());
      }catch (e) {
        console.log(row.name, row.sku)
      }
      // Return true if any of the conditions match
    })

    setAllProductsFiltred(array)
    }
  }, [isLoadingProducts, allProducts, searchAddModal]);



  //SELECTED SUPPLIERS FUNCTIONALITY
  useEffect(() => {
    if (suppliers.length > 0) {
      setCurrentSupplier(undefined);
    }
  }, [suppliers]);

  //CHANGE FIELDS OF ITEMS FUNCTIONALITY
  const handleChangeQuantity = (sku, quantity) => {
    setSelectedProducts((prevSelectedProducts) => {
      return prevSelectedProducts.map((product) => {
        if (product.sku === sku) {
          return { ...product, quantity };
        }
        return product;
      });
    });
  };

  const handleHistoryPavItemDelete = async (id) => {
    if (confirm('Are you sure want to delete this?')) {
      await historyPavItemDelete(id).then(() => {
        setTimeout(() => refetch(), 3000)
      })
    }
  }

  const handleChangeCogs = (sku, ourPrice) => {
    setSelectedProducts((prevSelectedProducts) => {
      return prevSelectedProducts.map((product) => {
        if (product.sku === sku) {
          return { ...product, ourPrice };
        }
        return product;
      });
    });
  };

  return (<>
        <button
            onClick={() => setIsModalOpen(true)}
            className='AddToStockButton'
        >
          History
        </button>

    <Modal
      open={isModalOpen} onClose={() => setIsModalOpen(false)}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          width: '900px',
          height: '600px',
          gap: '20px',
        }}
      >
        <Box
          className='AddToStockModal__header'
        >
          <Box  className='AddToStockModal__header__info'>
            <h1>History</h1>
            <p>{date}</p>
          </Box>
          <Box
            onClick={() => setIsModalOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1683_13517)">
                <path d="M3 3L17 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
                <path d="M17 3L3 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_1683_13517">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Box>
        </Box>
        
        <Box className='AddToStockModal__body'>
          <Box className='AddToStockModal__body__filters' style={{justifyContent: "space-between"}}>
            <AutocompleteTPO
              options={suppliers}
              filterOptions={(options, state) => 
                options.filter(option => 
                 ( option?.employee?.toLowerCase().includes(state?.inputValue?.toLowerCase())
                 || option?.pavilion?.toLowerCase().includes(state?.inputValue?.toLowerCase())
                ))
              }
              getOptionLabel={option => option.name}
              onChange={setCurrentSupplier}
              highlightMatches
              animations
              loadingText="We select suppliers..."
              noOptionsText="Nothing found"
            />
            <Box className='AddToStockModal__body__filters__search'>
              <input 
                value={searchModal}
                onChange={(e) => setSearchModal(e.target.value)}
                placeholder='Search item'
              />
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.69237 16.4164C3.69237 16.4004 3.68806 16.3858 3.68114 16.3739L3.65482 16.4001L3.61475 16.4324L1.07591 18.4818L1.07589 18.4818C1.06157 18.4933 1.04699 18.5045 1.03215 18.5152C0.973162 18.6425 0.995386 18.8007 1.09851 18.9049C1.21903 19.0267 1.40736 19.0315 1.53323 18.9193L3.6258 16.521L3.62577 16.521L3.63091 16.5152L3.68165 16.458C3.6883 16.4461 3.69237 16.4318 3.69237 16.4164ZM11.4224 1C9.41612 1 7.48986 1.80545 6.06793 3.24268C4.64565 4.68026 3.84472 6.6323 3.84472 8.66993C3.84472 12.916 7.24741 16.3399 11.4224 16.3399C15.5973 16.3399 19 12.916 19 8.66993C19 4.42383 15.5973 1 11.4224 1Z" stroke="#7E7E7E" strokeWidth="2" />
              </svg>
            </Box>
            <button
              onClick={() => {
                setCurrentSupplier(undefined)
                //setIsEditMode(!isEditMode)
              }}
              style={{ background: !isEditMode ? '#3bb77e' : '#bbb',  }}
              className='AddToStockButton saveBtn'
            >
              {!isEditMode ? 'Show All' : 'Show All'}
            </button>
          </Box>
          {historyPavilionProducts && <Box sx={{boxShadow: 'none', height: '376px', minWidth: 900, overflowY: 'scroll'}}>
            {[...historyPavilionProducts].reverse()
                .filter(elem => (elem?.contact?.employee.includes(currentSupplier?.employee)) || currentSupplier?._id == undefined || currentSupplier == null) 
                .filter(elem => normalizeToEnglish(elem.pavilionProducts.map(el => el.name?.toString()).join().toLowerCase()).includes(searchModal?.toLowerCase()))
                .map((item, index) => {
              return (<Box key={item._id+index} className='AddToStockModal__body__table__box' style={{marginBottom: "10px"}}>
                <Box className='AddToStockModal__body__table__header'>
                  <Box sx={{flex: 2, background: item?.toCheck ? '#fb3737' : '#3bb77e', rotate: currentOpenHistoryItem == item?.saveTime ? "180deg" : "0deg"}} onClick={() => setCurrentOpenHistoryItem(prev => prev == item?.saveTime ? "" : item?.saveTime)}>↯</Box>
                  <Box sx={{flex: 6, background: item?.toCheck ? '#fb3737' : '#3bb77e'}}>{item?.contact.tradeName}</Box>
                  <Box sx={{flex: 6, background: item?.toCheck ? '#fb3737' : '#3bb77e'}} onClick={() => handleUpdateFacturaNum(item)}>{item?.facturaNum || "Factura #123"}</Box>
                  <Box sx={{flex: 12, background: item?.toCheck ? '#fb3737' : '#3bb77e'}}>{item?.contact.name}</Box>
                  <Box sx={{flex: 5, background: item?.toCheck ? '#fb3737' : '#3bb77e'}} onClick={() => handleUpdateSaveTime(item)}>{item?.saveTime}</Box>
                  <Box sx={{
                    flex: 5,
                    background: item?.toCheck ? '#fb3737' : '#3bb77e'
                  }}>
                    {parseFloat(item?.pavilionProducts ? (item?.pavilionProducts.reduce((acc, curr) => acc + (curr.ourPrice *(1+parseInt(curr.IVA)/100)) * (curr.quantity || 0), 0)) : 0).toFixed(2)}€
                  </Box>
                  <Box sx={{flex: 3, background: item?.toCheck ? '#fb3737' : '#3bb77e'}}><img style={{height: '35px', borderRadius: '50px'}} src={item?.contact.img}/></Box>
                  <Box sx={{flex: 5, background: item?.toCheck ? '#fb3737' : '#3bb77e'}}><a style={{fontSize: "12px"}} href={item?.facturaLink} target="_blank" rel="noopener noreferrer">
                    FACTURA
                  </a>
                  </Box>
                  <Box sx={{flex: 3, background: item?.toCheck ? '#fb3737' : '#3bb77e', cursor:"pointer"}} onClick={() => handleHistoryPavItemDelete(item._id)}>x</Box>
                  <Box sx={{flex: 3, background: item?.toCheck ? '#fb3737' : '#3bb77e', cursor:"pointer"}}>
                    <EditStockHistoryModal
                      item={item}
                      allProducts={allProducts}
                      isLoadingProducts={isLoadingProducts}
                      contactsData={contactsData}
                    /> 
                  </Box>
                </Box>
                <TableContainer component={Paper}
                  sx={{display: (((item?.saveTime == currentOpenHistoryItem)) ? "block" : "none"), boxShadow: 'none', height: '376px', overflowY: 'scroll'}}>
                  <Table sx={{minWidth: 600, borderCollapse: 'separate', borderSpacing: '10px 16px'}}
                         aria-label='customized table' className='AddToStockModal__body__table'>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{textAlign: 'center'}}>
                          <Checkbox color={"success"} sx={{width: '26px', height: '26px'}}/>
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Img
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Product
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Quantity
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Cogs
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          IVA
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Status
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {item.pavilionProducts
                          //?.filter(elem => normalizeToEnglish(elem.name?.toString())?.toLowerCase().includes(searchModal?.toLowerCase()))
                          ?.map((elem, index) =>
                              <StockHistoryModalTableItem
                                  key={index}
                                  row={elem}
                                  selectedProducts={selectedProducts}
                                  setSelectedProducts={setSelectedProducts}
                                  isEditMode={isEditMode}
                                  handleChangeQuantity={handleChangeQuantity}
                                  handleChangeCogs={handleChangeCogs}
                              />
                          )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>)
            })}

          </Box>}
        </Box>
        
        {/*<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>*/}
        {/*  <Box*/}
        {/*    sx={{*/}
        {/*      display: 'flex',*/}
        {/*      justifyContent: 'flex-start',*/}
        {/*      alignItems: 'center',*/}
        {/*      width: '100%',*/}
        {/*      height: '40px',*/}
        {/*      gap: '10px'*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <button*/}
        {/*      onClick={() => {setIsLinkPDFModalOpen(true)}}*/}
        {/*      className='AddToStockButton'*/}
        {/*    >*/}
        {/*      Add PDF*/}
        {/*    </button>*/}
        {/*    <button*/}
        {/*      onClick={() => {setIsAddModalOpen(true)}}*/}
        {/*      style={{ minWidth: '106px',  }}*/}
        {/*      className='AddToStockButton'*/}
        {/*    >*/}
        {/*      Add Product*/}
        {/*    </button>*/}
        {/*    <button*/}
        {/*        onClick={() => {setIsAddModalOpen(true)}}*/}
        {/*        style={{ minWidth: '106px',  }}*/}
        {/*        className='AddToStockButton'*/}
        {/*    >*/}
        {/*      Delete Product*/}
        {/*    </button>*/}
        {/*  </Box>*/}
        {/*  <Box*/}
        {/*    sx={{*/}
        {/*      display: 'flex',*/}
        {/*      justifyContent: 'flex-end',*/}
        {/*      alignItems: 'center',*/}
        {/*      width: '100%',*/}
        {/*      height: '40px',*/}
        {/*      gap: '10px'*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <button*/}
        {/*      onClick={() => {*/}
        {/*        setIsModalOpen(false)*/}
        {/*      }}*/}
        {/*      style={{ background: '#ff725e' }}*/}
        {/*      className='AddToStockButton cancelBtn'*/}
        {/*    >*/}
        {/*      Cancel*/}
        {/*    </button>*/}
        {/*    <button*/}
        {/*      onClick={() => {*/}
        {/*        handleSaveProd()*/}
        {/*      }}*/}
        {/*      style={{ background: '#3bb77e' }}*/}
        {/*      className='AddToStockButton saveBtn'*/}
        {/*    >*/}
        {/*      Save*/}
        {/*    </button>*/}
        {/*  </Box>*/}
        {/*</Box>*/}
      </Box>
    </Modal>
    <Modal
      open={isAddModalOpen}
      onClose={() => setIsAddModalOpen(false)}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          width: '600px',
          height: '600px',
          gap: '20px',
        }}
      >
        <Box
          className='AddToStockModal__header'
        >
          <Box className='AddToStockModal__header__info'>
            <h1>Add item to list</h1>
          </Box>
          <Box
            onClick={() => setIsAddModalOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1683_13517)">
                <path d="M3 3L17 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
                <path d="M17 3L3 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_1683_13517">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', height: '100%' }}>
          <Box className='AddToStockModal__body__filters__search' sx={{ width: '100% !important', boxSizing: 'border-box'}}>
            <input 
              value={searchAddModal}
              onChange={(e) => setSearchAddModal(e.target.value)}
              placeholder='Search item'
            />
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.69237 16.4164C3.69237 16.4004 3.68806 16.3858 3.68114 16.3739L3.65482 16.4001L3.61475 16.4324L1.07591 18.4818L1.07589 18.4818C1.06157 18.4933 1.04699 18.5045 1.03215 18.5152C0.973162 18.6425 0.995386 18.8007 1.09851 18.9049C1.21903 19.0267 1.40736 19.0315 1.53323 18.9193L3.6258 16.521L3.62577 16.521L3.63091 16.5152L3.68165 16.458C3.6883 16.4461 3.69237 16.4318 3.69237 16.4164ZM11.4224 1C9.41612 1 7.48986 1.80545 6.06793 3.24268C4.64565 4.68026 3.84472 6.6323 3.84472 8.66993C3.84472 12.916 7.24741 16.3399 11.4224 16.3399C15.5973 16.3399 19 12.916 19 8.66993C19 4.42383 15.5973 1 11.4224 1Z" stroke="#7E7E7E" strokeWidth="2" />
            </svg>
          </Box>
          {isLoadingProducts ? <CircularProgress /> : <Box sx={{ overflowY: 'scroll', height: '500px' }}>
            {allProductsFiltred.sort((a, b) => {
              const aSelected = selectedProducts.map((el) => el?._id).includes(a._id);
              const bSelected = selectedProducts.map((el) => el?._id).includes(b._id);
              return (bSelected ? 1 : 0) - (aSelected ? 1 : 0);
            }).slice(0, showItemsLength).map((product) => (
              <Box
                className='AddToStockModal__body__item'
                key={product._id}
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2a2d2f'
                }}
              >
                <Box
                  className='AddToStockModal__body__item__checkbox'
                >
                  <input
                    type="checkbox"
                    checked={selectedProducts.map((el) => el?._id)?.includes(product._id)}
                    onClick={() => {
                      if (selectedProducts.map((el) => el?._id)?.includes(product._id)) {
                        setSelectedProducts([...selectedProducts.filter((el) => el._id !== product._id)]);
                        // console.log(selectedProducts);
                      } else {
                        setSelectedProducts([...selectedProducts, product]);
                        // console.log(selectedProducts);
                      }
                    }}
                  />
                </Box>
                <Box
                  className='AddToStockModal__body__item__info'
                >
                  <img src={product.img} width={30} height={30}/>
                </Box>
                <Box
                  className='AddToStockModal__body__item__info'
                >
                  <p>{product.name}</p>
                </Box>
                <Box
                  className='AddToStockModal__body__item__info'
                >
                  <p>{product.sku}</p>
                </Box>

              </Box>
            ))}
            {allProducts.length > showItemsLength && 
            <Box 
              onClick={() => setShowItemsLength(showItemsLength + 25)}
              sx={{
                borderRadius: '10px',
                background: '#37a975',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                color: '#fff',
                padding: '10px'
              }}  
            >
              Show more
            </Box>}
          </Box>}
        </Box>
      </Box>
    </Modal>
    <Modal
      open={isLinkPDFModalOpen}
      onClose={() => setIsLinkPDFModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          width: '600px',
          height: '90px',
          gap: '20px',
        }}
      >
        <Box
          className='AddToStockModal__header'
        >
          <Box className='AddToStockModal__header__info'>
            <h1>Add link of Factura</h1>
          </Box>
          <Box
            onClick={() => setIsLinkPDFModalOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1683_13517)">
                <path d="M3 3L17 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
                <path d="M17 3L3 17" stroke="#BBBBBB" strokeWidth="5" strokeLinecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_1683_13517">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            value={linkPDFValue}
            onChange={(e) => setLinkPDFValue(e.target.value)}
            className='AddToStockModal__input'
            placeholder='Link: https://example.com/factura.pdf'
          />
          <button className='AddToStockButton saveBtn' onClick={() => setIsLinkPDFModalOpen(false)} style={{ background: '#37a975'}}>
            Save
          </button>
        </Box>
      </Box>
    </Modal>
    </>
  )
}

export default AddToStockHistoryModal